import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=2a643fdf&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a643fdf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a643fdf')) {
      api.createRecord('2a643fdf', component.options)
    } else {
      api.reload('2a643fdf', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=2a643fdf&scoped=true&", function () {
      api.rerender('2a643fdf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubossBk/views/ticket2/ticketDesign/Index.vue"
export default component.exports